import { render, staticRenderFns } from "./Employees.container.vue?vue&type=template&id=85ae2f06&"
import script from "./Employees.container.vue?vue&type=script&lang=ts&"
export * from "./Employees.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports